import { render, staticRenderFns } from "./IconGluttenFreeOutline.vue?vue&type=template&id=5ec3efa2&"
import script from "./IconGluttenFreeOutline.vue?vue&type=script&lang=js&"
export * from "./IconGluttenFreeOutline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports